import React, { FC } from 'react'
import { Spacing } from 'Pages/landings/newLandings/common/style'
import { LayoutComponent } from 'Pages/landings/newLandings/common/Layout'
import { BannerComponent } from 'Pages/landings/newLandings/products/rkoPage/Banner'
import { AdvantagesComponent } from 'Pages/landings/newLandings/products/rkoPage/Advantages'
import { ServicePackagesComponent } from 'Pages/landings/newLandings/products/rkoPage/ServicePackages'
import { FreeServicesComponent } from 'Pages/landings/newLandings/products/rkoPage/FreeServices'
import { FormComponent } from 'Pages/landings/newLandings/products/rkoPage/Form'
import { CookieHandlingNotice } from 'Pages/landings/newLandings/common/components'

export const RkoPage: FC = () => (
	<LayoutComponent
		title="Бесплатно откройте счет в Сбере с экономией для бизнеса"
		menuButton="form"
		menuButtonText="Оставить заявку"
	>
		<Spacing height="32px" />
		<BannerComponent />
		<Spacing height="64px" heightLX="80px" />
		<AdvantagesComponent />
		<Spacing height="64px" heightLX="104px" />
		<ServicePackagesComponent />
		<Spacing height="64px" heightLX="88px" />
		<FreeServicesComponent />
		<Spacing height="64px" heightLX="104px" />
		<FormComponent className="ym-hide-content" />
		<CookieHandlingNotice />
	</LayoutComponent>
)
